// eslint-disable-next-line import-x/no-unassigned-import
import './.test/bootstrap';

import { createLogger } from '@svenskaspelab/nova-core/log';

const logger = createLogger('powerplay.instrumentation');

logger.debug('App initialized');
